import styled from "styled-components";

// libraries
import { Print, AccessTime, Edit } from "@libraries/icons";
import { BooleanLocale } from "yup/lib/locale";

const Container = styled.div`
  display: flex;
`;

interface IconContainerProps {
  color: string;
}

const IconContainer = styled.div<IconContainerProps>`
  svg {
    fill: ${({ color }) => color};
  }
`;

const CustomPrint = styled(Print)`
  cursor: pointer;
`;

const CustomAccessTime = styled(AccessTime)`
  cursor: pointer;
  color: #64dd17;
`;

const CustomEdit = styled(Edit)`
  cursor: pointer;
  color: #64dd17;
`;

export { Container, IconContainer, CustomPrint, CustomAccessTime, CustomEdit };
